// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1DatabasesReconcilerDatabaseSpec } from './V1DatabasesReconcilerDatabaseSpec';
import {
  V1DatabasesReconcilerDatabaseSpecFromJSON,
  V1DatabasesReconcilerDatabaseSpecFromJSONTyped,
  V1DatabasesReconcilerDatabaseSpecToJSON,
  V1DatabasesReconcilerDatabaseSpecToJSONTyped,
} from './V1DatabasesReconcilerDatabaseSpec';

/**
 *
 * @export
 * @interface V1ClusterDatabasesReconcilerSpec
 */
export interface V1ClusterDatabasesReconcilerSpec {
  /**
   *
   * @type {Array<V1DatabasesReconcilerDatabaseSpec>}
   * @memberof V1ClusterDatabasesReconcilerSpec
   */
  databases?: Array<V1DatabasesReconcilerDatabaseSpec>;
  /**
   *
   * @type {number}
   * @memberof V1ClusterDatabasesReconcilerSpec
   */
  version?: number;
}

/**
 * Check if a given object implements the V1ClusterDatabasesReconcilerSpec interface.
 */
export function instanceOfV1ClusterDatabasesReconcilerSpec(
  value: object,
): value is V1ClusterDatabasesReconcilerSpec {
  return true;
}

export function V1ClusterDatabasesReconcilerSpecFromJSON(
  json: any,
): V1ClusterDatabasesReconcilerSpec {
  return V1ClusterDatabasesReconcilerSpecFromJSONTyped(json, false);
}

export function V1ClusterDatabasesReconcilerSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterDatabasesReconcilerSpec {
  if (json == null) {
    return json;
  }
  return {
    databases:
      json['databases'] == null
        ? undefined
        : (json['databases'] as Array<any>).map(
            V1DatabasesReconcilerDatabaseSpecFromJSON,
          ),
    version: json['version'] == null ? undefined : json['version'],
  };
}

export function V1ClusterDatabasesReconcilerSpecToJSON(
  json: any,
): V1ClusterDatabasesReconcilerSpec {
  return V1ClusterDatabasesReconcilerSpecToJSONTyped(json, false);
}

export function V1ClusterDatabasesReconcilerSpecToJSONTyped(
  value?: V1ClusterDatabasesReconcilerSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    databases:
      value['databases'] == null
        ? undefined
        : (value['databases'] as Array<any>).map(
            V1DatabasesReconcilerDatabaseSpecToJSON,
          ),
    version: value['version'],
  };
}
